
<template>
  <div class="toCheck_box">
    <!-- 去检测，去买会员 -->
    <div class="noVip">
      <img class="head_bg"
           :src="blackJson.headPic"
           alt="">
      <!-- <p class="historyReport">历史报告 <span class="right_img"></span></p> -->
      <div class="aaa">
        <div class="con">
          <p class="con_title"><span class="title_left"></span><span class="con_con">{{baseInfo.hasMember?'请输入您的信息':'您的风险报告即将生成'}}</span><span class="title_right"></span></p>
          <div class="marquee"
               :class="{'marg1':baseInfo.hasMember==1}"
               v-if="marqueeList.length>0">
            <div class="marquee_box">
              <ul class="marquee_list"
                  :class="{marquee_top:animate}">
                <li v-for="(item, index) in marqueeList"
                    :key="index">
                  <span>{{item.title}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="con_box"
               v-if="baseInfo.hasMember=='0'">
            <!-- <span class="check_item_bg"></span> -->
            <img class="check_item_bg"
                 :src="blackJson.midPic"
                 alt="">
            <!-- <div class="ban_box">
              <div class="item">
                <span class="notVip_icon1"></span>
                <p>多头借贷</p>
              </div>
              <div class="item">
                <span class="icon1_1"></span>
                <span class="notVip_icon2"></span><br>
                <p>行业黑名单</p>
              </div>
              <div class="item">
                <span class="notVip_icon3"></span>
                <p>社会失信记录</p>
              </div>
            </div>
            <div class="ban_box ban_box1">
              <div class="item">
                <span class="notVip_icon4"></span>
                <p>金融失信行为</p>
              </div>
              <div class="item">
                <span class="notVip_icon5"></span>
                <p>贷款风险值过高</p>
              </div>
            </div> -->
          </div>
          <div class="con_box"
               v-if="baseInfo.hasMember==1">
            <div class="list_box">
              <ul>
                <li class="list">
                  <span class="list_icon"></span>
                  <input type="text"
                         maxlength="11"
                         placeholder="请输入您的姓名"
                         :disabled="baseInfo.hasRealName==1"
                         v-model="baseInfo.name">
                </li>
                <li class="list">
                  <span class="list_icon1"></span>
                  <input type="text"
                         maxlength="11"
                         placeholder="请输入注册手机号码"
                         v-model="baseInfo.phone">
                </li>
                <li class="list">
                  <span class="list_icon2"></span>
                  <input type="text"
                         placeholder="请输入本人的身份证号"
                         maxlength="18"
                         v-model="baseInfo.idcard">
                </li>
              </ul>
            </div>
          </div>

          <div class="buy_btn"
               v-if="baseInfo.hasMember=='0'"
               @click="toShow('h5_blacklist_buy_click')">
            <!-- <span>￥{{baseInfo.currentPrice}}</span> -->
            检测命中风险
            <!-- <span class="original_money">原价{{baseInfo.originalPrice}}
              <span class="sanjiao"></span>
            </span> -->
            <img src="@/assets/img/vip/check/check_but_tip.png" style="width: 0.68rem;height: 0.24rem;position: absolute;top: -0.2rem;right: 0rem;">
          </div>
          <div class="buy_btn"
               style="margin-top:.32rem;"
               :class="{'disabled':baseInfo.validNumber<0}"
               @click="check_black('h5_blacklist_query_click')"
               v-else>
            检测命中风险
            <span class="original_money">剩余{{baseInfo.validNumber}}次机会
              <span class="sanjiao"></span>
            </span>
          </div>

        </div>

        <div class="limit_bg">
          <!-- <span class="banner_bg"></span> -->
          <img :src=blackJson.footPic
               alt=""
               class="banner_bg">
        </div>
        <p class="notice">
          <img src="@/assets/img/vip/check/check_foot_step.png" style="width: 100%;height: 100%;">
        </p>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="shadow"
         v-if="isShowToast"></div>
    <div class="toast"
         v-if="isShowToast">
      <h1 class="toast_title"><span class="icon_left"></span>确认放弃检测吗？<span class="icon_right"></span></h1>
      <p class="toast_con">95%成功下款的用户，都先排查了被拒风险</p>
      <div class="btn_box">
        <span class="submit"
              @click="toHide">继续检测</span><br>
        <span class="reject"
              @click="toHide(1)">放弃</span>
      </div>
    </div>
    <PayToast :isShow="isShow"
              :isColor="isColor"
              :scenceCode="scenceCode"
              :memberTypeId="id"
              :payMoney="payMoney"
              :noJson="noJson"
              :isBlue="isBlue"
              :productId="productId"
              :orderId="orderId"
              :buyEntrance="buyEntrance"
              :eventKey="eventKey"></PayToast>
  </div>
</template>

<script>
import PayToast from '@/components/payToast';
import Echarts from '@/components/echarts'
import moment from "moment";

export default {
  components: {
    // Head,
    Echarts,
    PayToast
  },
  data () {
    return {
      isShowCheck: '',
      blackList: [],//黑名单弹窗列表
      isShowToast: false,
      noBack: false,
      eventKey: 'h5_blacklist_pay_click',
      payMoney: '19.9',
      noJson: true,
      isColor: false,
      isBlue: true,
      isShow: false,
      productId: 0,
      orderId: '',
      scenceCode: '5',
      buyEntrance: 2,//黑名单
      animate: false,
      marqueeList: [],
      timer: null,
      baseInfo: {
        name: '',
        phone: '',
        idcard: '',
        hasMember: '',//是否是会员
        pageUrl: '',
        adUrl: '',
        adId: '',
        hasProessinon: '',//是否是专业版
        hasRealName: 0,//1实名，0：未实名
        id: '',
      },
      reportType: '',//跳转类型
      blackJson: {},
      id: '',//3种不同的报告类型
      nowTime: moment().format('YYYY-MM-DD HH:mm:ss')
    }
  },
  mounted () {
    this.id = this.$route.query.id;
    this.isShowCheck = this.$route.query.isShowCheck;
    this.buyEntrance = this.$route.query.buyEntrance ? this.$route.query.buyEntrance : '2';
    this.util.title('检测页面');
    if (localStorage.getItem("token") == 'undefined' || localStorage.getItem("token") == '' || localStorage.getItem("token") == null) {
      //跳转到ios的登录页面
      this.toLogin();
    } else {
      this.getBlackCon();
      // this.getBlackList();
      // this.getVipList();
      setInterval(this.showMarquee, 2000)//轮播滚动
      this.getBlackInfo();
    }
  },
  beforeDestroy () {
    window.removeEventListener('popstate', this.goBack, false);
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    //去登录
    toLogin () {
      try {
        window.webkit.messageHandlers.toLogin.postMessage('');//ios
      } catch (err) {
        window.AppJs.toLogin();//android
      }
    },
    goBack () {
      if (this.noBack == false) {
        this.isShowToast = true;
        // this.$router.replace({ path: '/vip/creditCheck' });
        //replace替换原路由，作用是避免回退死循环
      } else {
        this.isShowToast = false;
        this.$router.back();
      }
    },
    toHide (isBack) {
      this.isShowToast = false;
      this.noBack = true;
      if (isBack == 1) {
        this.util.toClientPath(0)
      }
    },
    //获取黑名单信息
    getBlackCon () {
      let _this = this;
      this.$get('/app/h5/blackList/blacklistPage?id=' + _this.id)
        .then(res => {
          if (res.code == 200) {
            _this.blackJson = res.data.pageInfo;
            _this.payMoney = res.data.pageInfo.price
            _this.reportType = res.data.pageInfo.reportType;
            _this.util.title(res.data.pageInfo.title)
            res.data.headline.filter(function (item, index) {
              if (item.type == 4) {
                _this.marqueeList.push(item);
              }
            })
            console.log(res.data)
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    //获取黑名单种类
    getBlackList () {
      let _this = this;
      this.$get('/app/h5/blackList/getBlackList')
        .then(res => {
          if (res.code == 200) {
            _this.blackList = res.data;
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    //获取黑名单列表信息
    getBlackInfo () {
      let _this = this;
      this.$get('/app/h5/blackList/reduceValidNumber?type=' + this.isShowCheck + '&skinId=' + this.id)
        .then(res => {
          if (res.code == 200) {
            this.baseInfo = Object.assign(this.baseInfo, res.data)
            // this.payMoney = res.data.currentPrice;
            if (this.baseInfo.hasMember == 0) {
              this.toBlackView();//黑名单浏览页埋点
              if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.goBack, false);
              }
            }
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    //校验信息
    check_black () {
      if (this.baseInfo.validNumber == 0) {
        return false;
      }
      let _this = this;
      let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;//校验身份证号码
      if (this.baseInfo.name.length <= 0) {
        this.util.toast({ msg: '用户名不能为空' })
        return false;
      }
      if (this.baseInfo.idcard.length <= 0) {
        this.util.toast({ msg: '身份证不能为空' })
        return false;
      } else {
        if (!regIdNo.test(this.baseInfo.idcard)) {
          this.util.toast({ msg: '身份证号格式不正确' })
          return false;
        }
      }
      if (this.baseInfo.phone.length <= 0) {
        this.util.toast({ msg: '手机号码不能为空' })
        return false;
      } else {
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.baseInfo.phone))) {
          this.util.toast({ msg: '手机号码格式不正确' })
          return false;
        }
      }
      let parme = {
        mobile: this.baseInfo.phone,
        name: this.baseInfo.name,
        idCard: this.baseInfo.idcard,
        skinId: this.id,
        type: this.isShowCheck
      }
      this.toPost(parme);
    },
    //去检测提交
    toPost (parme) {
      let _this = this;
      _this.toCheckView();
      this.$post('/app/h5/blackList/blackListCertification', parme)
        .then(res => {
          if (res.code == 200) {
            if (_this.reportType == 4) {//场景4
              // 字符串
              this.$router.push({
                path: '/vip/checkPageVip1',
                query: {
                  webRefresh: '1'
                }
              });
            } else if (_this.reportType == 3) {//场景3
              // 字符串
              this.$router.push({
                path: '/vip/checkPageVip',
                query: {
                  webRefresh: '1'
                }
              });
            } else if (_this.reportType == 2) {//场景2——专业版
              // 字符串
              this.$router.push({
                path: '/vip/checkPage',
                query: {
                  webRefresh: '1'
                }
              });
            } else {//普通版
              this.$router.push({
                path: '/vip/checkList',
                query: {
                  webRefresh: '1'
                }
              });
            }

          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    toBannerClick () {
      let json = {
        event_key: 'h5_blacklist_advert_click',
        url: this.baseInfo.pageUrl,
        ad_id: this.baseInfo.adId
      }
      this.toCountPoint(json);
      window.location.href = this.baseInfo.pageUrl;
    },
    //黑名单页浏览埋点
    toBlackView () {
      let json = {
        event_key: 'h5_blacklist_view',
        skin_id: this.id,
        blacklist_status: this.baseInfo.hasMember,
        gmt_create: this.nowTime,
      }
      this.toCountPoint(json)
    },
    //立即检测埋点
    toCheckView () {
      let json = {
        event_key: 'h5_blacklist_query_click',
        skin_id: this.id,
        blacklist_status: this.baseInfo.hasMember
      }
      this.toCountPoint(json)
    },
    //统计埋点
    toCountPoint (json, pageUrl) {
      this.$get('/app/api/v1/newEventTrace', json)
        .then(res => {
          if (res.code == 200) {
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    showMarquee: function () {
      this.animate = true;
      setTimeout(() => {
        this.marqueeList.push(this.marqueeList[0]);
        this.marqueeList.shift();
        this.animate = false;
      }, 500);
    },
    // 获取动态
    getVipList () {
      let _this = this;
      this.$get('/app/api/v1/home/headline', {})
        .then(function (res) {
          if (res.code == 200) {
            res.data.filter(function (item, index) {
              if (item.type == 4) {
                _this.marqueeList.push(item);
              }
            })
          } else {
            _this.util.toast({ msg: res.message })
          }
        }).catch(function (error) {
          console.log('错误')
        });
    },
    toShow (eventKey) {
      let json = {
        event_key: eventKey,
      }
      this.toCountPoint(json);
      if (!Number(this.baseInfo.hasMember)) {
        this.isShow = true;
      }
    },
  }

}
</script>
<style scoped>
.toCheck_box {
  position: relative;
  background: #fff;
  top: 0;
  width: 100%;
}
.head_bg {
  /* background: url('../../assets/img/vip/check/check_header_bg.png') no-repeat
    top center;
  background-size: 100% 100%; */
  width: 100%;
  height: 2.54rem;
}
.historyReport {
  display: inline-block;
  width: 0.78rem;
  height: 0.29rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100px 0px 0px 100px;
  position: absolute;
  right: 0;
  top: 0.15rem;
  color: #fff;
  font-size: 0.12rem;
  padding: 0.05rem 0 0.08rem 0.12rem;
}
.right_img {
  display: inline-block;
  background: url('../../assets/img/vip/check/right_img.png') no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.06rem;
  height: 0.1rem;
  position: relative;
  top: 0.01rem;
}
.limit_bg {
  padding: 0 0.1rem;
  /* height: 1.33rem; */
  width: 100%;
}
.banner_bg {
  /* display: inline-block;
  background: url('../../assets/img/vip/check/check_banner_bg.png') no-repeat
    top center;
  background-size: 100% 100%; */
  width: 100%;
  /* height: 1.33rem; */
}
.notice {
  font-size: 0.12rem;
  color: #999999;
  text-align: center;
  padding-bottom: 0.2rem;
  width: 95%;
  margin: 0px auto;
}
.money {
  font-size: 0.34rem;
  font-family: DINAlternate-Bold;
  font-weight: bold;
  line-height: 34px;
  text-shadow: 0px 4px 10px rgba(255, 191, 128, 0.2);
}
.original_money {
  position: absolute;
  right: 0;
  top: -0.1rem;
  background: #fff;
  font-size: 0.1rem;
  border-radius: 5px;
  height: 0.2rem;
  line-height: 0.2rem;
  color: #3189f5;
  padding: 0 0.1rem;
  box-shadow: 0px 6px 10px 0px rgba(62, 139, 233, 0.49);
}
.sanjiao {
  background: url('../../assets/img/vip/check/sanjiao.png') no-repeat top center;
  background-size: 100% 100%;
  width: 0.07rem;
  height: 0.05rem;
  display: inline-block;
  position: absolute;
  top: 0.2rem;
  left: 0.1rem;
}
.undeline {
  text-decoration: line-through;
}
.buy_btn,
.pay_btn {
  color: #ffffff;
  font-size: 0.17rem;
  text-align: center;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 39px;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}
.buy_btn {
  margin-top: 0.06rem;
  position: relative;
  z-index: 11;
}
.disabled {
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 0.4) 0%,
    rgba(60, 100, 246, 0.4) 100%
  );
}
.pay_btn {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  margin-bottom: 0.3rem;
}
.noVip .con {
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(252, 120, 89, 0.15);
  border-radius: 6px;
  padding-bottom: 0.15rem;
  margin: 0.15rem 0.2rem;
  margin-bottom: 0.1rem;
}
.aaa {
  position: absolute;
  width: 100%;
  top: 1.7rem;
  /* padding: 0.15rem 0.2rem; */
}
.con {
  margin: 0.15rem 0.2rem;
}
.con .con_title {
  color: #333;
  font-size: 0.14rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  padding: 0.18rem 0;
  padding-bottom: 0.12rem;
}
.con .title_left,
.con .title_right {
  background: url('../../assets/img/vip/check/title_left.png') no-repeat center
    center;
  background-size: 100%;
  width: 0.2rem;
  height: 0.14rem;
  display: inline-block;
  position: relative;
  top: 0.02rem;
}
.con .title_right {
  background: url('../../assets/img/vip/check/title_right.png') no-repeat center
    center;
  background-size: 100%;
}
.con .con_con {
  margin: 0 0.1rem;
}
.shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.4;
  z-index: 11;
}
.con_box {
  margin: 0 0.2rem;
}
/* .con_box .check_item_bg {
  background: url('../../assets/img/vip/check/check_center_img.png') no-repeat
    top center;
  background-size: 100%;
  display: inline-block;
  height: 1.7rem;
  width: 100%;
} */
.con_box .check_item_bg {
  width: 100%;
}
.list_box input {
  border-bottom: 1px solid #e8e8e8;
  width: 85%;
  padding: 0.14rem 0.1rem;
  color: #333;
  font-size: 0.14rem;
}
.list_box .list_icon,
.list_box .list_icon1,
.list_box .list_icon2 {
  background: url('../../assets/img/vip/check/list_user.png') no-repeat center
    center;
  background-size: 100%;
  display: inline-block;
  width: 0.22rem;
  height: 0.22rem;
  position: relative;
  top: 0.06rem;
  margin-right: 0.1rem;
}
.list_box .list_icon1 {
  background: url('../../assets/img/vip/check/list_phone.png') no-repeat center
    center;
  background-size: 100%;
  display: inline-block;
  width: 0.22rem;
  height: 0.22rem;
}

.list_box .list_icon2 {
  background: url('../../assets/img/vip/check/list_card.png') no-repeat center
    center;
  background-size: 100%;
  display: inline-block;
  width: 0.22rem;
  height: 0.22rem;
}
.ban_box {
  display: flex;
  flex: 1;
  justify-content: space-around;
  margin-top: 0.2rem;
}
.ban_box {
  padding: 0 0.15rem;
}
.ban_box1 {
  padding: 0 0.65rem 0 0.65rem;
  justify-content: space-between;
  margin-top: 0.1rem;
}
.mt {
  margin-top: 0.2rem;
}
.ban_box .item {
  text-align: center;
  width: 0.84rem;
  position: relative;
  font-size: 0.12rem;
  color: #666;
}
.icon1_1 {
  background: url('../../assets/img/vip/check/icon1_1.png') no-repeat center
    center;
  background-size: 100%;
  width: 0.26rem;
  height: 0.13rem;
  display: inline-block;
  position: absolute;
  right: 0.02rem;
}

.notVip_icon1,
.notVip_icon2,
.notVip_icon3,
.notVip_icon4,
.notVip_icon5 {
  background: url('../../assets/img/vip/check/notVip_icon1.png') no-repeat
    center center;
  background-size: 100%;
  width: 0.56rem;
  height: 0.56rem;
  display: inline-block;
}
.notVip_icon2 {
  background: url('../../assets/img/vip/check/notVip_icon2.png') no-repeat
    center center;
  background-size: 100%;
}
.notVip_icon3 {
  background: url('../../assets/img/vip/check/notVip_icon3.png') no-repeat
    center center;
  background-size: 100%;
}
.notVip_icon4 {
  background: url('../../assets/img/vip/check/notVip_icon4.png') no-repeat
    center center;
  background-size: 100%;
}
.notVip_icon5 {
  background: url('../../assets/img/vip/check/notVip_icon5.png') no-repeat
    center center;
  background-size: 100%;
}
.marquee {
  width: 100%;
  /* height: 50px; */
  align-items: center;
  /* color: #3a3a3a; */
  /* background-color: #b3effe; */
  display: flex;
  box-sizing: border-box;
  margin-bottom: 0.2rem;
}
.marg1 {
  margin-bottom: 0.1rem;
}

.marquee_title {
  padding: 0 20px;
  height: 0.28rem;
  font-size: 0.12rem;
  border-right: 1px solid #d8d8d8;
  align-items: center;
}

.marquee_box {
  display: block;
  position: relative;
  width: 100%;
  height: 0.28rem;
  overflow: hidden;
  width: 2.41rem;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0px 0px 11px 0px rgba(214, 214, 214, 0.2);
  border-radius: 14px;
  text-align: center;
}

.marquee_list {
  display: block;
  color: #999;
}

.marquee_top {
  transition: all 0.5s;
  margin-top: -30px;
}

.marquee_list li {
  height: 0.28rem;
  line-height: 28px;
  font-size: 0.12rem;
}

.marquee_list li span {
  padding: 0 2px;
}

/* 弹窗 */
.shadow {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}
.toast {
  width: 2.75rem;
  height: 2rem;
  background: #fff;
  border-radius: 10px;
  z-index: 99;
  position: fixed;
  top: 1.62rem;
  left: 50%;
  transform: translate(-50%, 0%);
  padding: 0.2rem 0.15rem;
  text-align: center;
}
.btn_box {
  clear: both;
  overflow: hidden;
}

.reject {
  color: #999;
  font-size: 0.12rem;
  text-align: center;
}
.submit {
  display: inline-block;
  width: 1.91rem;
  height: 0.4rem;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  color: #fff;
  border-radius: 20px;
  text-align: center;
  line-height: 0.4rem;
  margin: 0.1rem auto;
}
.toast .item {
  margin: 0.15rem 0;
  background: #f5f5f5;
  padding: 0.15rem;
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.item div,
.item span {
  flex: 1;
}
.item .t_icon {
  background: url('../../assets/img/vip/detail_icon4.png') no-repeat top center;
  background-size: 100% 100%;
  margin-right: 0.1rem;
  width: 0.4rem;
  height: 0.4rem;
}
.item .t_icon img {
  width: 0.4rem;
  height: 0.4rem;
}
.item .money {
  color: #ee6c67;
  font-size: 0.16rem;
}
.toast .toast_con {
  color: #333;
  font-size: 0.14rem;
  width: 80%;
  margin: 0 auto;
}
.toast .toast_title {
  color: #527af5;
  font-size: 0.18rem;
  text-align: center;
  margin-bottom: 0.15rem;
}
.toast .icon_left,
.toast .icon_right {
  background: url('../../assets/img/vip/icon_left.png') no-repeat top center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.21rem;
  height: 0.04rem;
  position: relative;
  top: -0.05rem;
}
.toast .icon_left {
  margin-right: 0.1rem;
}
.toast .icon_right {
  background: url('../../assets/img/vip/icon_right.png') no-repeat top center;
  background-size: 100% 100%;
}
</style>
